/* eslint-disable react/prop-types */
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import { TableHead } from './ui/table';
import { cn } from '../lib/utils';

export default function SortableTableHead({
  children,
  ordering,
  onOrderingChange,
  asc,
  desc,
  defaultDirection = 'asc',
  className,
}) {
  const isAsc = ordering === asc;
  const isDesc = ordering === desc;
  const active = isAsc || isDesc;
  const nextOrdering = !active
    ? (defaultDirection === 'desc' ? desc : asc)
    : (isAsc ? desc : asc);
  const Icon = isAsc ? ArrowUp : isDesc ? ArrowDown : ArrowUpDown;

  return (
    <TableHead className={className} aria-sort={isAsc ? 'ascending' : isDesc ? 'descending' : 'none'}>
      <button
        type="button"
        onClick={() => onOrderingChange(nextOrdering)}
        className={cn(
          'inline-flex h-7 items-center gap-1.5 rounded px-1.5 -ml-1.5 transition-colors hover:bg-muted hover:text-foreground',
          active && 'text-foreground',
          className?.includes('text-right') && 'ml-auto -mr-1.5'
        )}
      >
        <span>{children}</span>
        <Icon className="h-3.5 w-3.5" />
      </button>
    </TableHead>
  );
}
